// extracted by mini-css-extract-plugin
export default {"container":"pt5M4jRU","gauge":"mX0cLNqJ"};